import gql from 'graphql-tag';

export default gql`
  fragment mailCommentActivityFragment on MailCommentActivity {
    id
    body
    bodyPlainText
  }
`;
